import { render, staticRenderFns } from "./RecipientSenderSelector.vue?vue&type=template&id=fa5df6d2&scoped=true"
import script from "./RecipientSenderSelector.vue?vue&type=script&lang=js"
export * from "./RecipientSenderSelector.vue?vue&type=script&lang=js"
import style0 from "./RecipientSenderSelector.vue?vue&type=style&index=0&id=fa5df6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5df6d2",
  null
  
)

export default component.exports